import generateContext, { createAction } from '..';

interface IErrorScreenState {
  show: boolean;
  message: string
  title: string
  confirmCallback: () => void
  ctaTitle:string
}

const defaultConfirmCallback = () => { console.warn('Callback not assigned') }

const initialState: IErrorScreenState = {
  show: false,
  message: '',
  title: '',
  confirmCallback: defaultConfirmCallback,
  ctaTitle: ''
};


enum ErrorScreenActionTypes {
  ShowErrorScreen = 'SHOW_ERROR_SCREEN',
  HideErrorScreen = 'HIDE_ERROR_SCREEN',
}
const reducer = (state: IErrorScreenState,
  action: { type: ErrorScreenActionTypes; payload?: any }): IErrorScreenState => {
  const { message = '', title = '', confirmCallback,ctaTitle } = action.payload || {}
  switch (action.type) {
    case ErrorScreenActionTypes.ShowErrorScreen:
      return {
        ...state,
        show: true,
        message: message,
        title: title,
        confirmCallback,
        ctaTitle: ctaTitle
      }
    case ErrorScreenActionTypes.HideErrorScreen:
      return {
        ...state,
        show: false,
        message: message,
        title: title,
        confirmCallback: defaultConfirmCallback,
        ctaTitle: ctaTitle
      };
    default:
      return state
  }
}


const [ErrorScreenCtxProvider, useErrorScreenState, useErrorScreenDispatch] =

  generateContext(reducer, initialState);

const useErrorScreenActions = () => {

  const dispatch = useErrorScreenDispatch();

  const showErrorScreen = (payload: Object) => {
    dispatch(createAction(ErrorScreenActionTypes.ShowErrorScreen, payload));
  };

  const hideErrorScreen = () => {
    dispatch(createAction(ErrorScreenActionTypes.HideErrorScreen));
  };

  return {
    showErrorScreen,
    hideErrorScreen
  };
}

export {
  ErrorScreenCtxProvider,
  useErrorScreenState,
  useErrorScreenActions,
};